import { render } from "./solid.vue?vue&type=template&id=72577613&scoped=true"
import script from "./solid.vue?vue&type=script&lang=js"
export * from "./solid.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72577613"]])

export default __exports__